import * as z from 'zod';
import { ContractSuretyType } from '../../../../../enums.mjs';
import '../../../../../types/actor/actor.mjs';
import '../../../../../types/address/address.mjs';
import '../../../../../types/credit-report/company-credit-report.mjs';
import '../../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../../types/currency/currency.mjs';
import '../../../../../types/entityRelation/entity-relation.mjs';
import '../../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../../types/financial-formula/adjustment.mjs';
import '../../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../../types/is-encrypted.mjs';
import '../../../../../types/naics-codes/naics-codes.mjs';
import { rateSchema, suretyBondId } from '../../../../../types/opaque.mjs';
import '../../../../../types/surety/account/requested-limits.mjs';
import '../../../../../types/surety/account/surety-account.types.mjs';
import '../../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../../types/surety/application-extraction/application-review.mjs';
import '../../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../../types/user/user.types.mjs';
import { currencySchema } from '../../../../../types/utils.mjs';
import { Import as Import$1 } from './admin-contract-surety-bond-mixins.dto.mjs';
import { Import as Import$2 } from './admin-final-contract-surety-bond.dto.mjs';

var Import;
(function (Import) {
    (function (Request) {
        Request.schema = Import$1.Request.baseSchema.extend({
            contractSuretyType: z.literal(ContractSuretyType.bid_to_final),
            rate: rateSchema,
            premium: currencySchema,
            bond: Import$1.Request.baseSchema.shape.bond.extend({
                bondCreatedFromId: suretyBondId,
                data: Import$2.Request.schema.shape.bond.shape.data.omit({ project: true }),
            }),
            bondForm: Import$1.Request.baseSchema.shape.bondForm.extend({
                data: Import$2.Request.schema.shape.bondForm.shape.data,
            }),
        });
    })(Import.Request || (Import.Request = {}));
})(Import || (Import = {}));

export { Import };
